import { CameraInstructions } from '../../../utils/platform';
import { FaVideoSlash } from 'react-icons/fa';

import './CameraPermissionModal.scss';

interface CameraPermissionModalProps {
    visible: boolean;
    instructions: CameraInstructions;
    onDismiss: () => void;
    onReload: () => void;
}

const CameraPermissionModal = ({ visible, instructions, onDismiss, onReload }: CameraPermissionModalProps) => {
    if (!visible) return null;

    return (
        <div className="camera-permission-modal">
            <div className="backdrop" onClick={onDismiss} />
            <div className="modal">
                <div className="modal-icon blocked">
                    <FaVideoSlash />
                </div>
                <div className="modal-content">
                    <h3 className="modal-title">{instructions.title}</h3>
                    <p className="modal-subtitle">
                        Camera access is needed to scan barcodes. Follow these steps to enable it:
                    </p>
                    <ol className="modal-steps">
                        {instructions.steps.map((step, i) => (
                            <li key={i}>{step}</li>
                        ))}
                    </ol>
                </div>
                <div className="modal-actions">
                    <button className="btn-dismiss" onClick={onDismiss}>
                        Dismiss
                    </button>
                    <button className="btn-reload" onClick={onReload}>
                        {instructions.actionLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CameraPermissionModal;
